import { billingService } from '../../services';
import { planService } from '../../services';

export const config: any = {
  createCheckout: (
    id: string,
    priceId: string,
    planName: string,
    PlanSubscriptionId: string,
    autoRenew: boolean,
    SubscriptionStatus: string
  ) =>
    billingService.createCheckout(
      id,
      priceId,
      planName,
      PlanSubscriptionId,
      autoRenew,
      SubscriptionStatus
    ),
  addCard: (id: string) => billingService.addCard(id),
  getCard: (id: string) => billingService.getCard(id),
  getPlans: (companyName: string) => billingService.getPlans(companyName),
  cancelSubscription: (PlanSubscriptionId: string) =>
    billingService.cancleSubscription(PlanSubscriptionId),
  deleteCard: (PaymentMethodId: string) =>
    billingService.deleteCard(PaymentMethodId),
  companyDetails: () => billingService.companyDetails(),
  retryPayment: (stripeCustomerId: string, planSubscriptionId: string) =>
    billingService.retryPayment(stripeCustomerId, planSubscriptionId),
  requestQuoteModal: (companyName: string, planName: string) =>
    billingService.requestQuote(companyName, planName),
  setAsDefault: (params: {
    stripe_customer_id: string;
    PaymentMethodId: string;
  }) => billingService.setAsDefault(params),
  getPlansInfo: (companyName: string) => planService.getAllPlans(),
  getCompanyPlan: (companyName: string) => planService.getPlanByCompany(companyName)
};
